import { createAction, props } from '@ngrx/store';
import { LoggedInOfficer } from '../models/logged-in-officer.models';

export const getCurrentOfficer = createAction('[OfficerDetails] getCurrentOfficer');
export const getCurrentOfficerSuccess = createAction('[OfficerDetails] getCurrentOfficerSuccess', props<{ officer: LoggedInOfficer }>());
export const updateCurrentOfficerSuccess = createAction('[OfficerDetails] updateCurrentOfficerSuccess', props<{ officer: LoggedInOfficer }>());

export const changeAutoClearFilters = createAction('[OfficerDetails] changeAutoClearFilters', props<{ newAutoClearFiltersValue: boolean }>());
export const changeAutoClearFiltersSuccess = createAction('[OfficerDetails] changeAutoClearFiltersSuccess', props<{ newAutoClearFiltersValue: boolean }>());
